import templateUrl from 'emun.auth/usergroups/usergroup-list.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";

class UserGroupListController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.query = new AutoQuery({
			url: 'QueryUserGroups.json',
			autoLoad: true,
			hideLeftNav: true
		});
		let $rootScope = resolve("$rootScope");
		$rootScope.$on("usergroupSaved", () => $ctrl.query.load(true));
    }
	create() {
		const $ctrl = this;
		$ctrl.$state.transitionTo("usergroup", { usergroupId: 'create' });
	}

	delete(usergroup) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to delete " + usergroup.name, "Delete User Group?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteUserGroup.json", usergroup)
					.then(function () {
						return $ctrl.query.load(true);
					})
					.catch(

					);
			});
	}
}

let UserGroupList = {
	controller: UserGroupListController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}

export default UserGroupList;
